<template>
	<div class="o-dashboard">

		<div class="o-dashboard__breadcrumbs">
			<ul class="c-breadcrumbs">
				<li>
					<a href="/voorraad">Voorraad</a>
				</li>
				<li>
					<span>{{ product.name }}</span>
				</li>
			</ul>
		</div>

		<c-splitbutton class="margin-b-24" :buttons="buttons" v-if="buttons.length > 0"></c-splitbutton>

		<div class="row margin-b-16 fs-xsmall">
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">Product</span>
			</div>
			<div class="columns small-12 medium-8">
				{{product.name}}
			</div>
		</div>

		<div class="row margin-b-16 fs-xsmall">
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">Omschrijving</span>
			</div>
			<div class="columns small-12 medium-8">
				{{product.description}}
			</div>
		</div>

		<div class="row margin-b-16 fs-xsmall">
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">Artikelnummer</span>
			</div>
			<div class="columns small-12 medium-8">
				{{product.article_number}}
			</div>
		</div>

		<div class="row margin-b-16 fs-xsmall">
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">Uniek ID</span>
			</div>
			<div class="columns small-12 medium-8">
				{{product.unique_product_id}}
			</div>
		</div>

		<div class="row margin-b-16 fs-xsmall">
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">EOL</span>
			</div>
			<div class="columns small-12 medium-8">
				{{ eol }}
			</div>
		</div>

		<div class="row margin-b-16 fs-xsmall">
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">Items</span>
			</div>
			<div class="columns small-12 medium-8">
				{{product.items_count}}
			</div>
		</div>

		<c-table
			:endpoint="'/api/getitems/' + this.$route.params.id"
			:placeholder="'Zoeken op serienummer, ordernummer of MAC Adres'"
			:columns="columns"
			:checkbox="true"
			ref="table"
		/>

		<c-new-stock v-if="product"
			v-show="modal"
			@close="modal=false"
			@added="load"
			:size="'medium'"
			:title="'Nieuw voorraad'"
			:edit="true"
			:item="product"
		/>

		<c-remove
			v-show="remove"
			:size="'medium'"
			text="voorraad"
			@close="remove=false"
			@remove="removeProduct()">
		</c-remove>

		<c-remove
			v-show="inactive"
			:size="'medium'"
			removeText="Inactief maken"
			text="voorraad"
			@close="inactive=false"
			@remove="inactiveProduct()">
		</c-remove>


	</div>
</template>

<script>
import View from '@mixins/View';
import Form from '@mixins/Form';
import CTable from '@components/table/Table';
import CBreadcrumbs from '@components/Breadcrumbs';
import CSplitbutton from '@components/Splitbutton';
import CNewStock from '@app/modals/NewStock';
import { mapGetters } from 'vuex';
import CRemove from '@app/modals/Remove';

export default {
	mixins: [ View, Form ],
	components: { CTable, CBreadcrumbs, CSplitbutton, CNewStock, CRemove},

	data() {
		return {
			modal: false,
			product: '',
			eol: '',
			remove: false,
			inactive: false,
		}
	},
	methods: {
		openModal() {
			this.modal = true;
		},
		openModalConfirm()	{
			this.remove = true;
		},
		openModalInactive() {
			this.inactive = true;
		},
		load() {
			this.$xhr.get("/api/products/" + this.$route.params.id)
				.then( ({result}) => {
					this.product = result;

					this.eol =  this.product.eol ? this.product.eol + ' maanden' : 'Niet bekend' ;
				})
				.catch(error => {
					this.$store.dispatch('toast/alert', {title: 'Foutmelding', text: 'Productgegevens kunnen niet worden ingeladen'});
				})

		},
        exportStockDetail() {
            const link = document.createElement('a');
            link.href = '/api/exportstockitems/' + this.$route.params.id;
            document.body.appendChild(link);
            link.click();
        },
		removeProduct(){
			this.$xhr.delete("/api/products/" + this.$route.params.id)
				.then( ({result}) => {
					this.$store.dispatch('toast/success', {title: 'Succes', text: 'Artikel is verwijderd'});
					this.$router.push({ name: 'stock' });
				})
				.catch(error => {
					this.$store.dispatch('toast/alert', {title: 'Foutmelding', text: 'Artikel kan niet worden verwijderd'});
				})
		},
		inactiveProduct(){
			this.$xhr.post("/api/products/" + this.$route.params.id + '/inactive')
				.then( ({result}) => {
					this.$store.dispatch('toast/success', {title: 'Succes', text: 'Artikel is inactief gemaakt'});
					this.$router.push({ name: 'stock' });
				})
				.catch(error => {
					this.$store.dispatch('toast/alert', {title: 'Foutmelding', text: 'Artikel kan niet inactief worden gemaakt'});
				})
		}
	},
	beforeUnmount(){
		this.$store.dispatch("listener/off", {
			event: 'newOrder',
			listener: this.openModal
		});
		this.$store.dispatch('listener/off', {
			event: 'new-stock',
			listener: this.openModal
		});
        this.$store.dispatch('listener/off', {
            event: 'export',
            listener: this.exportStockDetail
        });
		this.$store.dispatch("listener/off", {
			event: 'remove',
			listener: this.openModalConfirm
		});
		this.$store.dispatch("listener/off", {
			event: 'inactive',
			listener: this.openModalInactive
		});
	},
	created(){
		this.$store.dispatch("listener/on", {
			event: 'newOrder',
			listener: this.openModal
		});
		this.$store.dispatch('listener/on', {
			event: 'new-stock',
			listener: this.openModal
		});
        this.$store.dispatch('listener/on', {
            event: 'export',
            listener: this.exportStockDetail
        });
		this.$store.dispatch("listener/on", {
			event: 'remove',
			listener: this.openModalConfirm
		});
		this.$store.dispatch("listener/on", {
			event: 'inactive',
			listener: this.openModalInactive
		});
	},
	computed: {
		columns() {
			return [
				{ name: 'product.name', label: 'Productnaam', sortable: true, sort: false },
				{ name: 'serial', label: 'Serienummer', sortable: true },
				{ name: 'order_number', label: 'Ordernummer', sortable: true },
				{ name: 'mac_address', label: 'MAC Adres', sortable: true },
				{ name: 'tag_number', label: 'Asset ID', sortable: true },
				{ name: 'client.contact.first_name,client.contact.last_name', label: 'Eindgebruiker', sortable: true },
				{ name: 'eol_time', label: 'EOL periode', sortable: false },
				{ name: 'status.name', label: 'Status', sortable: true },
				{ name: "id", label: "", component: 'CColumnButton', props: { route: 'itemDetail' }},
			];

		},
		...mapGetters({
			can: 'user/can',
			user: 'user/get'
		}),
		buttons() {

			const buttons = [];
			this.can('Voorraad wijzigen') && buttons.push({
				label: 'Bewerken',
				action: () => {
					this.$store.dispatch('listener/emit', 'new-stock')
				},
			});
			// only available when there are no items and user is superuser
			this.product.items_count == 0 && this.can('Voorraad verwijderen') && buttons.push({
				label: 'Verwijderen',
				action: () => {
					this.$store.dispatch('listener/emit', 'remove')
				},
			});

			this.can('Voorraad verwijderen') && buttons.push({
				label: 'Inactief maken',
				action: () => {
					this.$store.dispatch('listener/emit', 'inactive')
				},
			});

			return buttons;
		}


	},
	mounted() {
		this.load();
	}
}
</script>
